import { LitElement, html } from 'lit';
import styles from './fit-spinner.css';

/**
 * Show a spinner so the user knows something is loading or happening.
 * Size, color and secondary color are customizable
 *
 * @element fit-spinner
 */
export class FitSpinner extends LitElement {
  static get is() { return 'fit-spinner'; }

  static get styles() { return styles; }

  render() {
    return html`
      <div class="fit-spinner__circle"></div>
    `;
  }

  get _size() {
    return this.spinnerSize || 24;
  }

  get _thickness() {
    return Math.round(this._size / 10 + 1);
  }

  get _lineColor() {
    return this.spinnerColor || 'var(--primary-color--400)';
  }

  get _gapColor() {
    return this.spinnerSecondaryColor || 'transparent';
  }

  static get properties() {
    return {
      /**
       * 'spinner-size' defines the width and height of the spinner.
       * It has to be a number, ex: '48'
       * The default value (if attribute does not exist) is 24(px)
       * @Number
       */
      spinnerSize: {
        type: Number,
        attribute: 'spinner-size',
      },

      /**
       * 'spinner-color' defines the color of the spinner.
       * It has to be a valid css color, ex: 'green" or "#ff0000'
       * The default value (if attribute does not exist) is 'var(--primary-color-400)'
       * @String
       */
      spinnerColor: {
        type: String,
        attribute: 'spinner-color',
      },

      /**
       * 'spinner-secondary-color' defines the color of the spinner's 'top segment'.
       * It has to be a valid css color, ex: 'green" or "#ff0000'
       * The default value (if attribute does not exist) is 'transparent'
       * @String
       */
      spinnerSecondaryColor: {
        type: String,
        attribute: 'spinner-secondary-color',
      },
    };
  }

  updated() {
    const spinnerStyles = this.shadowRoot.querySelector('.fit-spinner__circle').style;
    spinnerStyles.borderRight = `${this._thickness}px solid ${this._lineColor}`;
    spinnerStyles.borderLeft = `${this._thickness}px solid ${this._lineColor}`;
    spinnerStyles.borderBottom = `${this._thickness}px solid ${this._lineColor}`;
    spinnerStyles.borderTop = `${this._thickness}px solid ${this._gapColor}`;
    spinnerStyles.height = `${this._size}px`;
    spinnerStyles.width = `${this._size}px`;
  }
}

customElements.define(FitSpinner.is, FitSpinner);
